import { render } from "./BaseIcon.vue?vue&type=template&id=ba5c8126&scoped=true&ts=true&lang=pug"
import script from "./BaseIcon.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=ba5c8126&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5c8126"]])

export default __exports__